import React from "react";

import Works from "../../images/works.svg";

import LazyLoad from 'react-lazyload';

const HowItWorks = () => {
  return (
    <section id="howItWorks">
      <div className="px-4 py-5 container-fluid">
        <div className="row no-gutters my-5">
          <div className="col-10 offset-1 text-center">
            <h2>HOW IT WORKS</h2>
            <hr className="hr-line2"/>
          </div>
        </div>
        <div className="row no-gutters my-5">
          <div className="col-12 col-lg-6 col-xl-5 offset-xl-1 border-right mb-5">
            <LazyLoad once={true} debounce={false}>
              <img src={Works} alt="Schema how it works"/>
            </LazyLoad>
          </div>
          <div className="col-11 col-lg-5 offset-1 offset-lg-1">
            <h4>1. Create</h4>
            <p>First a NFT reward is created</p>
            <br/>
            <h4>2. Lock</h4>
            <p>Then ERC20 tokens are locked and farming starts</p>
            <br/>
            <h4>3. Wait</h4>
            <p>Then a locking period must pass</p>
            <br/>
            <h4>4. Claim</h4>
            <p>Finally, deserved rewards can be claimed and enjoyed</p>
          </div>
        </div>
        {/*<div className="row no-gutters my-5">*/}
        {/*    <div className="col-12 text-center">*/}
        {/*        <button className="btn btn-secondary btn-scale">Find Out More {'>'}</button>*/}
        {/*    </div>*/}
        {/*</div>*/}
      </div>
    </section>
  )
};

export default HowItWorks;